import { graphql } from "gatsby";
import PropTypes from "prop-types";
import React, { useEffect } from "react";

import Header from "~/components/Header";

import withTranslationProps from "~/hoc/withTranslationProps";
import HeaderTranslator from "~/translators/Header";

const HeaderBlock = ({ headerNotSticky = false, translator, data }) => {
    const { wp } = data;

    useEffect(() => {
        translator.maybeRedirect();
        translator.maybeUpdateUrl();
    }, [translator]);

    const { languages, navigation } = translator.translate(
        wp?.navigationOptionsTranslations,
    );

    const headerLogo = navigation?.headerLogo ?? null;
    const locationSiteLinks = navigation.locationSiteLinks ?? null;
    const topNav = navigation?.headerTopNavigation ?? null;
    const mainNav = navigation?.mainNavigation ?? null;
    const headerSearchOptions = navigation?.headerSearchOptions ?? null;

    return (
        <Header
            {...{
                headerLogo,
                locationSiteLinks,
                topNav,
                mainNav,
                headerSearchOptions,
                headerNotSticky,
                languages,
            }}
        />
    );
};

HeaderBlock.propTypes = {
    headerNotSticky: PropTypes.bool,
};

export default withTranslationProps(HeaderBlock, HeaderTranslator);

export const query = graphql`
    query HeaderBlockQuery {
        wp {
            navigationOptionsTranslations {
                languageCode
                headerLogo {
                    altText
                    title
                    sourceUrl
                }
                locationSiteLinks {
                    currentLocation
                    additionalSiteLocations {
                        linkLabel
                        linkUrl
                    }
                }
                headerTopNavigation {
                    linkUrl
                    linkLabel
                    subNavigationItems {
                        linkLabel
                        linkUrl
                    }
                }
                mainNavigation {
                    linkLabel
                    linkUrl
                    singleColumnSubNavigation
                    numberOfColumns
                    type
                    links {
                        linkLabel
                        linkUrl
                        subNavigation: subNavigationItems {
                            linkLabel
                            linkUrl
                        }
                    }
                    cards {
                        logo {
                            altText
                            title
                            sourceUrl
                        }
                        logoBackgroundColor
                        title
                        subTitle
                        productsImage {
                            altText
                            title
                            sourceUrl
                        }
                        buttonLabel
                        buttonUrl
                        additionalLinks {
                            linkLabel
                            linkUrl
                        }
                    }
                    iconLinks {
                        iconName
                        linkLabel
                        linkUrl
                    }
                }
                headerSearchOptions {
                    text
                    value
                    pageUrl
                }
            }
        }
    }
`;
